/**
 * 종목 뉴스 카드 공통 컴포넌트 — 시장인사이트 페이지 / 종목 상세 드로어 공용
 * newsQ를 내장 (queryKey: ["market","news",symbol,overseas])
 */
import { Card, Empty, Spin } from "antd";
import dayjs from "dayjs";
import { useQuery } from "@tanstack/react-query";
import { marketApi } from "src/api/market";

interface StockNewsCardProps {
  symbol: string;
  overseas?: boolean;
  /** 표시 뉴스 수 (기본 10) */
  limit?: number;
  /** 목록 최대 높이 px (기본 340) */
  maxHeight?: number;
  enabled?: boolean;
}

const StockNewsCard = ({
  symbol,
  overseas = false,
  limit = 10,
  maxHeight = 340,
  enabled = true,
}: StockNewsCardProps) => {
  const newsQ = useQuery({
    queryKey: ["market", "news", symbol, overseas],
    queryFn: () => marketApi.getNews(symbol, overseas),
    enabled: enabled && !!symbol,
    staleTime: 5 * 60_000,
    retry: 1,
  });

  return (
    <Card size="small" title="📰 관련 뉴스">
      {newsQ.isLoading ? (
        <Spin style={{ display: "block", margin: "30px auto" }} />
      ) : newsQ.isError ? (
        <Empty description="뉴스를 불러올 수 없습니다" style={{ margin: "30px 0" }} />
      ) : (newsQ.data || []).length > 0 ? (
        <div style={{ maxHeight, overflowY: "auto" }}>
          {(newsQ.data || []).slice(0, limit).map((n) => (
            <div key={n.id} style={{ padding: "8px 0", borderBottom: "1px solid var(--app-color-border-secondary)" }}>
              <div style={{ fontSize: 13, fontWeight: 500, lineHeight: 1.4 }}>{n.title}</div>
              <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                {n.source} · {n.datetime ? dayjs(n.datetime, "YYYYMMDD HHmmss").format("MM.DD HH:mm") : ""}
              </div>
            </div>
          ))}
          {(newsQ.data || []).length > limit && (
            <div style={{ fontSize: 11, color: "#999", textAlign: "center", paddingTop: 6 }}>
              외 {(newsQ.data || []).length - limit}건
            </div>
          )}
        </div>
      ) : (
        <Empty description="뉴스 없음" />
      )}
    </Card>
  );
};

export default StockNewsCard;
